import AddProductPage from './AddProductPage.jsx';

export default AddProductPage;